import Concerts from '../components/Concerts'
import PassedConcerts from '../components/PassedConcerts'

function Home({ t, lang }) {
  return (
        <main className="page-container bg-custom">
          <div className='container text-center'>
            <h1 className='page-title'>AGENDA</h1> 
            <Concerts t={t} lang={lang} />
            <h1 className='page-title' style={{fontSize:'1.8rem'}}>{t("past_concerts").toUpperCase()}</h1>
            <PassedConcerts t={t} lang={lang} />

          </div>    
        </main>
  );
}

export default Home;